import dayjs from 'dayjs'
import { getLsUserInfo } from '@/core/storage/ls'

const waterMark = {
  // 指令挂载时触发
  mounted(el, binding) {
    // 水印文字，父元素，画布宽度，画布高度，字体，文字颜色，画布横坐标
    function addWaterMarker(
      str,
      phone,
      parentNode,
      width,
      height,
      font,
      fillTextX = "10"
    ) {
      // 检查父元素是否包含子元素
      const elementContains = (parent, child) =>
        parent !== child && parent.contains(child);

      const flag = elementContains(
        parentNode,
        document.querySelector("canvas")
      );

      // 防止重复创建
      if (!flag) {
        const can = document.createElement("canvas");
        parentNode.appendChild(can);
        can.width = width || 330;
        can.height = height || 30;
        can.id = "canvas";
        can.style.display = "none";
        const cans = can.getContext("2d");
        cans.font = font || "16px Microsoft Yahei";
        cans.fillStyle = "#fff";
        cans.textAlign = "start";
        cans.textBaseline = "bottom";
        cans.fillText(str, fillTextX, can.height);
        cans.textAlign = "end";
        cans.fillText(phone, can.width, can.height);

        // 创建水印覆盖层
        const div = document.createElement("div");
        div.id = str;
        div.style.pointerEvents = "none";
        div.style.top = "0";
        div.style.left = "0";
        div.style.position = "absolute";
        div.style.zIndex = "100000";
        div.style.width = "100%";
        div.style.height = "100%";
        div.style.background = `url(${can.toDataURL("image/png")}) no-repeat`;
        parentNode.appendChild(div);
      }
    }

    // 获取绑定值
    let phone = getLsUserInfo().phone.substring(0, 3) + '****' + getLsUserInfo().phone.substring(7)
    addWaterMarker(
      binding.value.text = binding.value.text || dayjs().format('YYYY-MM-DD dddd HH:mm:ss'),
      binding.value.phone = binding.value.phone || phone,
      el,
      binding.value?.width,
      binding.value?.height,
      binding.value?.font,
      binding.value?.textColor,
      binding.value?.fillTextX
    );
  },
};

export default waterMark;
